import ServiceBlock from "./ServiceBlock";

export interface ServiceBlocksProps {
  id: string;
  serviceBlocks?: {
    step: string;
    title: string;
    text: string;
    className?: string;
  }[];
}

const ServiceBlocks = ({ ...props }: ServiceBlocksProps) => {
  return (
    <div className="bg-background" id={props.id}>
      <div className="gs--page-column py-16">
        <div className="flex flex-wrap gap-0">
          {props.serviceBlocks?.map((block, index) => (
            <ServiceBlock
              key={index}
              className={block.className}
              step={block.step}
              title={block.title}
              text={block.text}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceBlocks;
